import { EmployeeIdentificationType, EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';
import { Assets, Box, Button, Container, Flex, Headings, Link, VerticalSpacer } from '@foradevelopment/fora-ui';

import { AddressDetails, PersonDetails } from '../../components';
import { useTypedTranslation } from '../../i18n/i18n';
import { links } from '../../router/links';
import { getCountryFromCode } from '../../common/utils';
import { useAppSelector } from '../../redux/hooks';

type EditEmployeeConfirmationDetailsProps = {
  goBackToEditPanel: () => void;
  employment: EmploymentViewModelNew;
};

export const EditEmployeeConfirmationDetails = ({
  employment,
  goBackToEditPanel,
}: EditEmployeeConfirmationDetailsProps) => {
  const { t } = useTypedTranslation();
  const countries = useAppSelector(state => state.foraGlobal.countries);

  const { employee } = employment;

  return (
    <Container maxWidth={578} width="100%">
      <Assets.CheckmarkIcon color="black" width={30} />
      <VerticalSpacer marginBottom={10} />
      <Headings.H2>{t('panel.employeeAddedOrUpdated.confirmationEditText')}</Headings.H2>
      <VerticalSpacer marginBottom={60} />
      <Flex justifyContent="space-between" alignItems="center">
        <PersonDetails {...employee} />
        <Box alignSelf="flex-start">
          <VerticalSpacer marginBottom={5} />
          <Button styleAs="link" onClick={goBackToEditPanel}>
            {t('common.edit')} <Assets.EditIcon marginLeft={5} />
          </Button>
        </Box>
      </Flex>
      {employment.policyNumber &&
      employment.employee.identificationType === EmployeeIdentificationType.CoOrdinationNumber &&
      !employment.employee.isVerified ? (
        <>
          <VerticalSpacer marginBottom={10} />
          <AddressDetails
            {...employee.address}
            country={getCountryFromCode(countries, employment.employee.address.countryCode)}
          />
        </>
      ) : null}
      <VerticalSpacer marginBottom={60} />
      <Container>
        <Flex rowGap={20} columnGap={20} flexWrap="wrap">
          <Link styleAs="button" to={links.employments} hasIcon={false} fullWidth={false}>
            {t('panel.employeeAddedOrUpdated.buttonTextShowAllEmployments')}
          </Link>
        </Flex>
      </Container>
    </Container>
  );
};
